"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizeDirection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const hooks_1 = require("../../hooks");
var ResizeDirection;
(function (ResizeDirection) {
    ResizeDirection[ResizeDirection["All"] = 0] = "All";
    ResizeDirection[ResizeDirection["Width"] = 1] = "Width";
    ResizeDirection[ResizeDirection["Height"] = 2] = "Height";
    ResizeDirection[ResizeDirection["Diagonal"] = 3] = "Diagonal";
})(ResizeDirection || (exports.ResizeDirection = ResizeDirection = {}));
function StickyResizeCorner({ direction, currentSize, minimumSize, className, onResizeStart = noop_1.default, onResizing = noop_1.default, onResizeEnd = noop_1.default, }) {
    const cornerRef = (0, react_1.useRef)(null);
    // Maintain aspect ratio for diagonal resizing
    const maintainAspectRatio = (width, height, aspectRatio) => {
        let newWidth = width;
        let newHeight = height;
        if (width / height > aspectRatio) {
            newWidth = height * aspectRatio;
        }
        else {
            newHeight = width / aspectRatio;
        }
        return { width: newWidth, height: newHeight };
    };
    const checkSizeConstraints = (width, height) => {
        let newWidth = width;
        let newHeight = height;
        const aspectRatio = currentSize.width / currentSize.height;
        if (direction === ResizeDirection.Width) {
            newHeight = currentSize.height;
        }
        if (direction === ResizeDirection.Height) {
            newWidth = currentSize.width;
        }
        if (direction === ResizeDirection.Diagonal) {
            const adjustedSize = maintainAspectRatio(width, height, aspectRatio);
            newWidth = adjustedSize.width;
            newHeight = adjustedSize.height;
            // Ensure the new size respects the minimum size while maintaining aspect ratio
            if (newWidth < minimumSize.width || newHeight < minimumSize.height) {
                const scale = Math.max(minimumSize.width / newWidth, minimumSize.height / newHeight);
                newWidth = newWidth * scale;
                newHeight = newHeight * scale;
            }
        }
        else {
            newWidth = Math.max(newWidth, minimumSize.width);
            newHeight = Math.max(newHeight, minimumSize.height);
        }
        return { width: newWidth, height: newHeight };
    };
    const onResizeHandler = (delta) => {
        var _a;
        const { x, y } = delta;
        let width = Math.round(currentSize.width + x);
        let height = Math.round(currentSize.height + y);
        const newSize = checkSizeConstraints(width, height);
        const element = (_a = cornerRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
        if (element) {
            element.style.width = `${newSize.width}px`;
            element.style.height = `${newSize.height}px`;
        }
        onResizing(newSize);
    };
    const onResizeEndHandler = (delta) => {
        const { x, y } = delta;
        let width = Math.round(currentSize.width + x);
        let height = Math.round(currentSize.height + y);
        const newSize = checkSizeConstraints(width, height);
        onResizeEnd(newSize);
    };
    (0, hooks_1.useDrag)(cornerRef, onResizeStart, onResizeHandler, onResizeEndHandler);
    return (0, jsx_runtime_1.jsx)(Container, { className: className, ref: cornerRef, role: "button", "data-e2e": 'StickyResizeCorner_Container' });
}
exports.default = StickyResizeCorner;
const Container = styled_components_1.default.div `
  position: absolute;

  z-index: 1;

  width: 20px;
  height: 20px;

  &::after {
    position: absolute;
    top: 6px;
    left: 6px;

    width: 5px;
    height: 5px;

    background-color: ${({ theme }) => theme.text};

    border: 1px solid ${({ theme }) => theme.backgroundQuaternary};

    border-radius: 50%;

    content: '';
  }
`;
